var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUserTf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00004 1.33333C6.25337 1.33333 4.83337 2.75333 4.83337 4.49999C4.83337 6.21333 6.17337 7.59999 7.92004 7.65999C7.97337 7.65333 8.02671 7.65333 8.06671 7.65999C8.08004 7.65999 8.08671 7.65999 8.10004 7.65999C8.10671 7.65999 8.10671 7.65999 8.11337 7.65999C9.82004 7.59999 11.16 6.21333 11.1667 4.49999C11.1667 2.75333 9.74671 1.33333 8.00004 1.33333Z",
    fill: "#808985"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3866 9.43333C9.52664 8.19333 6.49331 8.19333 4.61997 9.43333C3.77331 9.99999 3.30664 10.7667 3.30664 11.5867C3.30664 12.4067 3.77331 13.1667 4.61331 13.7267C5.54664 14.3533 6.77331 14.6667 7.99997 14.6667C9.22664 14.6667 10.4533 14.3533 11.3866 13.7267C12.2266 13.16 12.6933 12.4 12.6933 11.5733C12.6866 10.7533 12.2266 9.99333 11.3866 9.43333Z",
    fill: "#808985"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUserTf);
export default __webpack_public_path__ + "static/media/Icon_userTF.77e0f0d2168c59e2f7cdf692afa5e3cc.svg";
export { ForwardRef as ReactComponent };